/// <amd-module name="Dashboards/DashboardView/src/redux/selectors/ReducerSelectors" />
import * as Reselect from "Reselect";

import { DashboardViewState } from "../../model/DashboardViewState";
import { Widget } from "../../model/Widget";
import { toBooleanAssociativeArray } from "./SelectorHelpers";

/**
 * Selectors that operate on a subset of the state.
 * To be used only by Reducers and as shared logic in the normal selectors.
 */

// #region Basic Selectors - Simply return pieces of the store state.

export function dashboardIsInitialized(state: DashboardViewState): boolean {
    return state.dashboardIsInitialized;
}

export function getWidgetsSeen(state: DashboardViewState): ReadonlyArray<string> {
    return state.widgetsSeen;
}

export function getWidgets(state: DashboardViewState): ReadonlyArray<Widget> {
    return state.widgets;
}

// #endregion Basic Selectors

// #region Memoized Selectors - Simple caching selectors.

export const getWidgetIds = Reselect.createSelector(
    getWidgets,
    widgets => widgets.map(w => w.id!)
);

export const getWidgetsSeenMap = Reselect.createSelector(
    getWidgetsSeen,
    getWidgetIds,
    toBooleanAssociativeArray
);

// #endregion Memoized Selectors
